import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import ContentWrapper from "../Layout/ContentWrapper";
import { Card, CardBody, CardHeader, CardTitle } from "reactstrap";

import listPlugin from "@fullcalendar/list";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import { toast } from "../../../helpers/message-helper";
import timeGridPlugin from "@fullcalendar/timegrid";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import interactionPlugin from "@fullcalendar/interaction";

import "@fullcalendar/core/main.css";
import "@fullcalendar/bootstrap/main.css";
import { useRef } from "react";

const DEFAULT_SELECTED_COLOR = "danger";

const ListaEventos = ({
    eventos,
    onSeleccionEvento,
    eventoSelecionado,
    eventosLabel,
}) => {
    return (
        <Card className="card-default" title="">
            <CardHeader>
                <CardTitle tag="h4">{eventosLabel}</CardTitle>
            </CardHeader>
            <CardBody>
                <div className="external-events">
                    {eventos.length == 0 ? (
                        <label>No hay eventos</label>
                    ) : (
                        eventos.map((ev, i) => (
                            <div
                                onClick={() => onSeleccionEvento(ev.id)}
                                key={`${ev.title}-${ev.className}-${ev.id}`}
                                data-event={JSON.stringify({
                                    ...ev,
                                    index: i,
                                })}
                                className={`${ev.className} d-flex justify-content-between align-items-center`}
                            >
                                <span>{ev.title}</span>
                                {ev.id == eventoSelecionado && (
                                    <i className="fas fa-check"></i>
                                )}
                            </div>
                        ))
                    )}
                </div>
            </CardBody>
        </Card>
    );
};

ListaEventos.propTypes = {
    eventos: PropTypes.array,
    onSeleccionEvento: PropTypes.func,
    eventoSelecionado: PropTypes.string,
    eventosLabel: PropTypes.string,
};

const CardCrearEventos = ({
    title,
    inputValue,
    onClickColor,
    handleInputName,
    addNewExternalEvent,
}) => {
    return (
        <Card className="card-default">
            <CardHeader>
                <CardTitle tag="h4">{title}</CardTitle>
            </CardHeader>
            <CardBody>
                <div className="input-group mb-2">
                    <input
                        type="text"
                        placeholder="Eventos"
                        value={inputValue}
                        className="form-control"
                        onChange={handleInputName}
                    />
                    <div className="input-group-btn">
                        <button
                            className="btn btn-secondary"
                            onClick={addNewExternalEvent}
                            type="button"
                        >
                            <i className="fas fa-plus"></i>
                        </button>
                    </div>
                </div>
                <p className="text-muted">
                    <small>Escoge un color!</small>
                </p>
                <ListaColores onClickColor={onClickColor} />
            </CardBody>
        </Card>
    );
};

CardCrearEventos.propTypes = {
    title: PropTypes.string,
    inputValue: PropTypes.string,
    onClickColor: PropTypes.func,
    handleInputName: PropTypes.func,
    addNewExternalEvent: PropTypes.func,
};

const ListaColores = ({ onClickColor }) => {
    const [selected, setSelected] = useState(DEFAULT_SELECTED_COLOR);
    const evColors = [
        "danger",
        "primary",
        "info",
        "success",
        "warning",
        "green",
        "pink",
        "inverse",
        "purple",
    ];

    const getEvColorClasses = (color) => {
        return `bg-${color}` + (selected === color ? " selected" : "");
    };

    const seleccionarColor = (color) => {
        onClickColor(color);
        setSelected(color);
    };

    return (
        <ul className="list-inline" id="external-event-color-selector">
            {evColors.map((color) => (
                <li className="list-inline-item p-0" key={color}>
                    <div
                        className={
                            "circle circle-xl " + getEvColorClasses(color)
                        }
                        onClick={() => seleccionarColor(color)}
                    ></div>
                </li>
            ))}
        </ul>
    );
};

ListaColores.propTypes = {
    onClickColor: PropTypes.func
}

const CalendarioEventos = ({
    eventos = [],
    onEventoClick,
    fechaInicio,
    fechaFin,
    onFechaPulsada,
    onEventoAñadido,
    tipoVista = "dayGridMonth",
    dependeDeEventos = false,
    eventosLabel = "Eventos",
    eventosSeleccionados = [],
    crearEventoLabel = "Crear Evento",
    botonesDerechaCalendario = "",
    fechaSeleccionada,
    horasDeNegocio,
}) => {
    const [eventosCalendario, setEventosCalendario] =
        useState(eventosSeleccionados);

    const calendarRef = useRef(null);
    const [eventoSeleccionado, setEventoSeleccionado] = useState(null);
    const calendarPlugins = [
        listPlugin,
        dayGridPlugin,
        timeGridPlugin,
        bootstrapPlugin,
        interactionPlugin,
    ];

    useEffect(() => {
        if (eventosSeleccionados.length == 0 && eventosCalendario.length == 0) {
            return;
        }

        const eventos = eventosSeleccionados.map((item) => {
            return { ...item, extendedProps: item };
        });

        setEventosCalendario(eventos);
    }, [eventosSeleccionados]);

    useEffect(() => {
        calendarRef.current.getApi().changeView(tipoVista, fechaSeleccionada);
    }, [tipoVista]);

    const calendarHeader = {
        left: "prev,next",
        center: "title",
        right: botonesDerechaCalendario,
    };

    const [state, setState] = useState({
        evNewName: "",
        evSelectedColor: DEFAULT_SELECTED_COLOR,
        selectedEvent: null,
    });

    const dateClick = (date) => {
        if (!dependeDeEventos) {
            return onFechaPulsada && onFechaPulsada(date.dateStr);
        }

        if (eventoSeleccionado == null)
            return toast.error("Debes seleccionar un evento.");
        const evento = eventos.find((ev) => ev.id == eventoSeleccionado);
        onFechaPulsada && onFechaPulsada(date.dateStr, evento);
        setEventoSeleccionado(null);
    };

    const onSeleccionEvento = (id) => {
        setEventoSeleccionado(id);
    };

    const addNewExternalEvent = () => {
        const { evSelectedColor, evNewName } = state;
        if (evNewName == "" || evNewName == null) return;

        onEventoAñadido &&
            onEventoAñadido({
                className: `bg-${evSelectedColor}`,
                title: evNewName,
            });

        setState((prev) => ({ ...prev, evNewName: "" }));
    };

    const selectColor = (color) => {
        setState((prev) => ({ ...prev, evSelectedColor: color }));
    };

    const handleInputName = (event) => {
        setState((prev) => ({ ...prev, evNewName: event.target.value }));
    };

    return (
        <ContentWrapper>
            <div className="calendar-app">
                <div className="row">
                    {dependeDeEventos && (
                        <div className="col-xl-3 col-lg-4">
                            <div className="row">
                                <div className="col-lg-12 col-md-6 col-12">
                                    <ListaEventos
                                        eventos={eventos}
                                        eventosLabel={eventosLabel}
                                        onSeleccionEvento={onSeleccionEvento}
                                        eventoSelecionado={eventoSeleccionado}
                                    />
                                </div>
                                <div className="col-lg-12 col-md-6 col-12">
                                    <CardCrearEventos
                                        title={crearEventoLabel}
                                        inputValue={state.evNewName}
                                        handleInputName={handleInputName}
                                        addNewExternalEvent={
                                            addNewExternalEvent
                                        }
                                        onClickColor={(color) =>
                                            selectColor(color)
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                    <div
                        className={
                            dependeDeEventos ? "col-xl-9 col-lg-8" : "col-12"
                        }
                    >
                        <Card className="card-default">
                            <CardBody>
                                <FullCalendar
                                    locale="es"
                                    editable={false}
                                    droppable={false}
                                    ref={calendarRef}
                                    allDayDefault={false}
                                    allDaySlot={false}
                                    dateClick={dateClick}
                                    selectOverlap={false}
                                    slotDuration={"00:60:00"}
                                    defaultView={tipoVista}
                                    header={calendarHeader}
                                    plugins={calendarPlugins}
                                    themeSystem="bootstrap"
                                    validRange={{
                                        start: fechaInicio,
                                        end: fechaFin,
                                    }}
                                    eventClick={onEventoClick}
                                    deepChangeDetection={true}
                                    displayEventEnd={true}
                                    eventTimeFormat={{
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        second: "2-digit",
                                        hour12: false,
                                    }}
                                    events={eventosCalendario}
                                    businessHours={horasDeNegocio}
                                />
                            </CardBody>
                        </Card>
                    </div>
                </div>
            </div>
        </ContentWrapper>
    );
};

CalendarioEventos.propTypes = {
    eventos: PropTypes.array,
    onEventoClick: PropTypes.func,
    fechaInicio: PropTypes.string,
    fechaFin: PropTypes.string,
    onFechaPulsada: PropTypes.func,
    onEventoAñadido: PropTypes.func,
    tipoVista: PropTypes.string,
    dependeDeEventos: PropTypes.bool,
    eventosLabel: PropTypes.string,
    eventosSeleccionados: PropTypes.array,
    crearEventoLabel: PropTypes.string,
    botonesDerechaCalendario: PropTypes.string,
    fechaSeleccionada: PropTypes.string,
    horasDeNegocio: PropTypes.array,
}

export default CalendarioEventos;
